import useFetch from "use-http";
import { TopoJSON } from "highcharts";
import { getAbsoluteServerUrl } from "../config/config";


export function useGetTopojson() {
    return useFetch<TopoJSON>(getAbsoluteServerUrl(`/map/topojson`), { responseType: 'json' }, [])
}

export function useGetMunicipalitiesTopojson() {
  return useFetch<TopoJSON>(getAbsoluteServerUrl(`/map/municipalities/topojson`), { responseType: 'json' }, [])
}

export function useGetProvincesTopojson() {
  return useFetch<TopoJSON>(getAbsoluteServerUrl(`/map/provinces/topojson`), { responseType: 'json' }, [])
}